import { render, staticRenderFns } from "./ProgressoSpedizione.vue?vue&type=template&id=b7332368&scoped=true"
import script from "./ProgressoSpedizione.vue?vue&type=script&lang=ts"
export * from "./ProgressoSpedizione.vue?vue&type=script&lang=ts"
import style0 from "./ProgressoSpedizione.vue?vue&type=style&index=0&id=b7332368&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7332368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7332368')) {
      api.createRecord('b7332368', component.options)
    } else {
      api.reload('b7332368', component.options)
    }
    module.hot.accept("./ProgressoSpedizione.vue?vue&type=template&id=b7332368&scoped=true", function () {
      api.rerender('b7332368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProgressoSpedizione.vue"
export default component.exports